import { render } from "./termsConditions.vue?vue&type=template&id=fe0ee178"
import script from "./termsConditions.vue?vue&type=script&lang=js"
export * from "./termsConditions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__